export default "__VITE_ASSET__Ci43rkz4__"